/**
 * Index Module04 View
 */
class IndexModule04View {

	constructor(presenter, sectionId) {

		this.parent = $("#shopify-section-" + sectionId);
		this.swiper = this.parent.find("div.swiper").first();
		this.swiperButtonPrev = this.parent.find("button.mon-swiper-prev").first();
		this.swiperButtonNext = this.parent.find("button.mon-swiper-next").first();
//		this.productDescription = this.parent.find(".mon-product-description > div");		
		this.presenter = presenter;

		/*
		 * Listeners
		 */

		// this.productDescription.on("mouseenter", function(_event) {
			
		// 	const description = $(this);
		// 	const timeoutId = description.attr("data-timeout-id");

		// 	// check to see if the description element has a timeout id
		// 	if (timeoutId != null && timeoutId.length > 0 && Number.isInteger(timeoutId) == true) {
		// 		// it does, and as we no longer want the product description to collapse, cancel the timeout and remove its id from the product description
		// 		clearTimeout(timeoutId);
		// 		description.removeAttr("data-timeout-id");
		// 	}
			
		// 	// expand the product description
		// 	try { bootstrap.Collapse.getOrCreateInstance(description.find(".collapse").first()).hide(); } catch(_error) {}
		// 	try { bootstrap.Collapse.getOrCreateInstance(description.find(".collapse").last()).show(); } catch(_error) {}

		// });

		// this.productDescription.on("mouseleave", function(_event) {
			
		// 	const description = $(this);
		// 	var timeoutId = description.attr("data-timeout-id");

		// 	// if there is already a timer that should collapse the product description, just return
		// 	if (timeoutId != null && timeoutId.length > 0 && Number.isInteger(timeoutId) == true) { return; }

		// 	// setup a timeout that handles collapsing the product description
		// 	timeoutId = setTimeout(function() {
		// 		// collapse the product description, then remove the timer id from the description element
		// 		try { bootstrap.Collapse.getOrCreateInstance(description.find(".collapse").first()).show(); } catch(_error) {}
		// 		try { bootstrap.Collapse.getOrCreateInstance(description.find(".collapse").last()).hide(); } catch(_error) {}
		// 		description.removeAttr("data-timeout-id");
		// 	}, 1000);
			
		// 	// add the timer id to the description element
		// 	description.attr("data-timeout-id", timeoutId);

		// });

		/*
		 * Initialisation
		 */

		new Swiper(this.swiper.get(0), {
			slidesPerView: 2,
			slidesPerGroup: 2,
			breakpoints: {
				// > 540px is the bootstrap container width threshold before the md breakpoint starts
				541: {
					slidesPerView: 3,
					slidesPerGroup: 3
				},
				// > 768px is the bootstrap container width threshold before the lg breakpoint starts
				769: {
					slidesPerView: 4,
					slidesPerGroup: 4
				}
			},
			navigation: {
				prevEl: this.swiperButtonPrev.get(0),
				nextEl: this.swiperButtonNext.get(0)
			},
			spaceBetween: 8
		});

	}

	/*
	 * Actions
	 */

	/*
	 * Getters and Setters
	 */

}